import './App.css';
import RegisterPage from './pages/Register';
import RegisterSuccessPage from './pages/RegisterSuccess';
import LoginPage from './pages/Login';
import LogsPage from './pages/Logs';
import LinkAccountPage from './pages/LinkAccount';
import LinkAccountAgainPage from './pages/LinkAccountAgain';
import FiltersPage from './pages/Filters';
import SMSVerificationPage from './pages/SMSVerification';
import InvoiceSentSuccessPage from './pages/InvoiceSentSuccess';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useSelector } from 'react-redux';
import { ThemeProvider, defaultTheme } from 'evergreen-ui';
import { LayoutProvider, TokenProvider } from './providers';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import EmailVerificationPage from './pages/EmailVerification';
import EmailVerificationSuccessPage from './pages/EmailVerificationSuccess';
import AccountLinkingSuccessPage from './pages/LinkAccountSuccess';
import DashboardPage from './pages/Dashboard';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const NotFoundPage = () => {
  const location = useLocation();
  const queryParams = location.search
    .replace('?', '')
    .split('&')
    .reduce((acc, el) => {
      const [key, val] = el.split('=');
      acc[key] = val;
      return acc;
    }, {});
  if (queryParams.redirect === 'register') {
    return <Navigate to="/app/register" replace />;
  }
  if (queryParams.redirect === 'logs') {
    return <Navigate to="/app/logs" replace />;
  }
  if (queryParams.redirect === 'filters') {
    return <Navigate to="/app/filters" replace />;
  }
  return <Navigate to="/app/login" replace />;
};

function App() {
  const user = useSelector(state => state.authentication.user);
  const page = useSelector(state => state.session.page);
  const customTheme = {
    ...defaultTheme,
    colors: {
      ...defaultTheme.colors,
      blue500: '#e78850', // #e78850
      primaryOrange: '#E78850',
      inactiveOrange: '#644839',
    },
  };
  const renderLoginOrRegister = () => {
    if (page === 'register') return <RegisterPage />;
    if (page === 'registerSuccess') return <RegisterSuccessPage />;
    return <LoginPage />;
  };

  const renderSafeRoute = Component => {
    const numberVerificationNeeded = user && !user.isPhoneNumberVerified;
    const linkNeeded = user && !user.userID && !numberVerificationNeeded;
    // const linkAgainNeeded = user && user.unauthorized && !numberVerificationNeeded && !linkNeeded;
    if (!user) return <Navigate to="/app/login" replace />;
    if (numberVerificationNeeded) return <SMSVerificationPage />;
    if (linkNeeded) return <LinkAccountPage />;
    // if (linkAgainNeeded) return <LinkAccountAgainPage />;
    return <Component />;
  };
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider value={customTheme}>
        <LayoutProvider>
          <TokenProvider>
            <Router>
              <Routes>
                <Route
                  path="/app/logs"
                  element={renderSafeRoute(() => (
                    <LogsPage />
                  ))}
                />
                <Route path="/app/login" element={<LoginPage />} />
                <Route path="/app/register" element={<RegisterPage />} />
                <Route path="/app/emailVerification" element={<EmailVerificationPage />} />
                <Route path="/app/emailVerificationSuccess" element={<EmailVerificationSuccessPage />} />
                <Route path="/app/registerSuccess" element={<RegisterSuccessPage />} />
                <Route path="/app/accountRelinking" element={<LinkAccountAgainPage />} />
                <Route path="/app/accountLinkingSuccess" element={<AccountLinkingSuccessPage />} />
                <Route
                  path="/app/filters"
                  element={renderSafeRoute(() => (
                    <FiltersPage />
                  ))}
                />
                <Route
                  path="/app/invoiceSentSuccess"
                  element={renderSafeRoute(() => (
                    <InvoiceSentSuccessPage />
                  ))}
                />
                <Route
                  path="/app"
                  element={renderSafeRoute(() => (
                    <DashboardPage />
                  ))}
                />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Router>

            {/* {!user && renderLoginOrRegister()}
            {linkNeeded && <LinkAccountPage />}
            {linkAgainNeeded && <LinkAccountAgainPage />}
            {numberVerificationNeeded && <SMSVerificationPage />} */}

            {/* {isLogged && page === 'logs' && <LogsPage />} */}
            {/* {isLogged && page === 'filters' && <FiltersPage />} */}
            {/* {isLogged && page === 'invoiceSentSuccess' && <InvoiceSentSuccessPage />} */}
          </TokenProvider>
        </LayoutProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
